import SearchBtnSVG from '@/assets/icons/searchBtn.svg';
import { observer } from 'mobx-react';
import { useSearchParams } from 'next/navigation';
import { useState } from 'react';
import styles from './searchBar.module.scss';

interface ISearchBar {}

const SearchBar: React.FC<ISearchBar> = observer(() => {
  const [keyword, setKeyword] = useState('');
  const searchParams = useSearchParams();

  const handleInputChange = (e: any) => {
    setKeyword(e.target.value);
  };

  const handleSearchClick = () => {
    if (keyword.trim()) {
      window.location.href = `/s?k=${encodeURIComponent(keyword.trim())}`;
    }
  };

  const handleInputClick = () => {
    const channelPageName = searchParams.get('channelPageName') || undefined;
    if (['/', '/cms/home'].includes(new URL(location.href).pathname)) {
      let url = `/s`;
      if (channelPageName) {
        url += `?channelPageName=${channelPageName}`;
      }
      window.location.href = url;
    }
  };

  return (
    <div className={styles.mainWrap}>
      <div className={styles.inputWrap}>
        <input
          type='text'
          className={styles.input}
          onChange={handleInputChange}
          onClick={handleInputClick}
          autoComplete='off'
        />
        <button className={styles.searchBtn} onClick={handleSearchClick} aria-label='search button'>
          <SearchBtnSVG style={{ color: '#1A1A1A' }} />
        </button>
      </div>
    </div>
  );
});

export default SearchBar;
